<template>
  <div class="approved-claim-details">
    <Typography variant="body-2" class="paid-info" v-if="claim.payoutAmount">
      Paid:
      <strong class="paid-amount">{{ formatCurrency(claim.payoutAmount, Award, true) }}</strong>
    </Typography>
    <Typography variant="body-2" class="paid-date" v-if="claim.payoutDate">
      {{ formattedPayoutDate }}
    </Typography>
    <Typography variant="body-2" v-if="!claim.payoutAmount">
      {{ claim.reviewStatus }}
    </Typography>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import formatCurrency from "@/mixins/formatCurrency.js";
import moment from "moment";
export default {
  name: "ApprovedClaimDetails",
  components: {
    Typography,
  },
  computed: {
    formattedPayoutDate() {
      return moment(this.claim.payoutDate).format("M/D/YYYY");
    },
    Award() {
      return (
        (this.claim &&
          this.claim.Program &&
          this.claim.Program.Budget &&
          this.claim.Program.Budget.Award) ||
        null
      );
    },
  },
  mixins: [formatCurrency],
  props: {
    claim: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.approved-claim-details {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 1.5rem;
}

.paid-info {
  white-space: nowrap;
  flex-grow: 1;
  flex-shrink: 0;
}

.paid-amount {
  color: var(--v-success-lighten1);
}

.paid-date {
  color: var(--v-grey-darken3);
  white-space: nowrap;
  flex-shrink: 0;
}
</style>
